interface HTMLElement {
    attr(Key, Value): HTMLElement;
    val(Value): HTMLElement;
    setText(Text): HTMLElement;
    //getData(key): any;
    //setData(key, value): HTMLElement;
    //removeData(key): HTMLElement;
    addClass(...Keys: string[]): HTMLElement;
    removeClass(...Keys: string[]): HTMLElement;
    hasClass(Key: string): boolean;
    //toggleShow(): HTMLElement;
    //toggleHide(): HTMLElement;
    //toggle(Show?): HTMLElement;
}

/*interface Window {
    DataStorage: any;
}
window.DataStorage = new WeakMap();*/

HTMLElement.prototype.attr = function (Key, Value) {
    if (Value == null)
        this.removeAttribute(Key);
    else
        this.setAttribute(Key, Value);
    return this;
};
HTMLElement.prototype.val = function (Value) {
    if (Value === undefined)
        Value = null;
    this.value = Value;
    return this;
};
HTMLElement.prototype.setText = function (Text) {
    this.innerText = Text;
    return this;
};
/*HTMLElement.prototype.setData = function (key, value) {
    if (!window.DataStorage.has(this))
        window.DataStorage.set(this, new Map());
    window.DataStorage.get(this).set(key, value);
    return this;
};
HTMLElement.prototype.getData = function (key) {
    return window.DataStorage.get(this).get(key);
};
HTMLElement.prototype.removeData = function (key) {
    window.DataStorage.get(this).delete(key);
    if (window.DataStorage.get(this).size !== 0)
        window.DataStorage.delete(this);
    return this;
};*/

HTMLElement.prototype.addClass = function (...Keys: string[]) {
    this.classList.add.apply(this.classList, Keys);
    return this;
};
HTMLElement.prototype.removeClass = function (...Keys: string[]) {
    this.classList.remove.apply(this.classList, Keys);
    return this;
};
HTMLElement.prototype.hasClass = function (Key: string) {
    return this.classList.contains(Key);
};

/*HTMLElement.prototype.toggleShow = function () {
    this.style.display = 'block';
    return this;
}
HTMLElement.prototype.toggleHide = function () {
    this.style.display = 'none';
    return this;
}
HTMLElement.prototype.toggle = function (Show?) {
    if (Show == null)
        Show = window.getComputedStyle(this).display !== 'block';
    if (Show)
        return this.toggleShow();
    else
        return this.toggleHide();
}*/